import React from 'react';

export default function Border(props) {
  const { color } = props;
  return <div className="border-line" style={{ borderColor: color }} />;
}
